var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{ref:"site_button",class:[
		'cbre-c-ctaLink',
		{
			'cbre-c-ctaLink--white': _vm.white,
			'cbre-is-disabled': _vm.disabled,
			'cbre-c-ctaLink--externalIcon': _vm.external,
		},
	],attrs:{"href":_vm.parsedLink ? _vm.parsedLink.url : null,"target":_vm.parsedLink ? _vm.parsedLink.target : null,"aria-disabled":_vm.disabled ? 'true' : 'false',"data-auto":"pagecard-cta-link"},on:{"mouseenter":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false},"click":_vm.checkEmpty}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.button_label ? _vm.button_label : _vm.parsedLink ? _vm.parsedLink.title : ''))]}),_vm._v(" "),(_vm.external)?_c('span',{staticClass:"cbre-c-ctaLink--externalIcon"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/PrimaryButtonAlt.vue